// eslint-disable-next-line max-statements
export const copyContentToClipboard = (element) => {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(element.innerText);
    }
    try {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection?.removeAllRanges();
        selection?.addRange(range);
        document.execCommand('copy');
        return Promise.resolve();
    }
    catch (error) {
        const message = error instanceof Error ? error.message : error;
        return Promise.reject(message);
    }
};
export const copyValueToClipboard = (element) => {
    const { value } = element;
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(value);
    }
    try {
        element.select();
        element.setSelectionRange(0, element.value.length);
        document.execCommand('copy');
        return Promise.resolve();
    }
    catch (error) {
        const message = error instanceof Error ? error.message : error;
        return Promise.reject(message);
    }
};
